import styled from 'styled-components';
import FileImg from '../../assets/onboarding/file.svg';

const FileIcon = styled(FileImg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '3.3rem'};
  display: flex;
`;

export default FileIcon;
